import { Typography } from '@mui/material'
import { TableListPageManagement } from '../../components/TableListPageManagement/TableListPageManagement'
import * as S from './ProductPagesManagement.styles'

const ProductPagesManagement = () => (
  <S.Wrapper>
    <Typography variant='h5' fontWeight='bold'>Gerenciamento de páginas de produtos</Typography>
    <TableListPageManagement />
  </S.Wrapper>
)

export default ProductPagesManagement
